// extracted by mini-css-extract-plugin
export var classicActive = "Tabs-module--classicActive--159bb";
export var classicPanel = "Tabs-module--classicPanel--a6fda";
export var classicTab = "Tabs-module--classicTab--5a466";
export var classicTabs = "Tabs-module--classicTabs--ad17a";
export var hotelActive = "Tabs-module--hotelActive--737d5";
export var hotelIcon = "Tabs-module--hotelIcon--95621";
export var hotelPanel = "Tabs-module--hotelPanel--52e93";
export var hotelTab = "Tabs-module--hotelTab--1d9f0";
export var hotelTabs = "Tabs-module--hotelTabs--60206";
export var hotelTabsLButton = "Tabs-module--hotelTabsLButton--9a37e";
export var hotelTabsRButton = "Tabs-module--hotelTabsRButton--332a6";
export var hotelTabsWrapper = "Tabs-module--hotelTabsWrapper--78851";
export var iconActive = "Tabs-module--iconActive--d723f";
export var iconIcon = "Tabs-module--iconIcon--ad632";
export var iconPanel = "Tabs-module--iconPanel--e88b4";
export var iconTab = "Tabs-module--iconTab--3e66c";
export var iconTabs = "Tabs-module--iconTabs--92c75";
export var iconTabsLButton = "Tabs-module--iconTabsLButton--c5429";
export var iconTabsRButton = "Tabs-module--iconTabsRButton--85903";
export var iconTabsWrapper = "Tabs-module--iconTabsWrapper--27974";
export var merchActive = "Tabs-module--merchActive--2b6aa";
export var merchMobileActive = "Tabs-module--merchMobileActive--2ca87";
export var merchMobilePanel = "Tabs-module--merchMobilePanel--7c720";
export var merchMobileTab = "Tabs-module--merchMobileTab--a691d";
export var merchMobileTabs = "Tabs-module--merchMobileTabs--3c44e";
export var merchMobileTabsLButton = "Tabs-module--merchMobileTabsLButton--886d1";
export var merchMobileTabsRButton = "Tabs-module--merchMobileTabsRButton--3d685";
export var merchMobileTabsWrapper = "Tabs-module--merchMobileTabsWrapper--b907d";
export var merchPanel = "Tabs-module--merchPanel--41c41";
export var merchTab = "Tabs-module--merchTab--ac94b";
export var merchTabs = "Tabs-module--merchTabs--45218";
export var merchTabsLButton = "Tabs-module--merchTabsLButton--debc1";
export var merchTabsRButton = "Tabs-module--merchTabsRButton--0bf66";
export var merchTabsWrapper = "Tabs-module--merchTabsWrapper--afa9a";
export var pillsActive = "Tabs-module--pillsActive--8fbd6";
export var pillsPanel = "Tabs-module--pillsPanel--b505f";
export var pillsTab = "Tabs-module--pillsTab--2af98";
export var pillsTabs = "Tabs-module--pillsTabs--f79a3";
export var pillsTabsLButton = "Tabs-module--pillsTabsLButton--47aa1";
export var pillsTabsRButton = "Tabs-module--pillsTabsRButton--a23ba";
export var pillsTabsWrapper = "Tabs-module--pillsTabsWrapper--a4c01";
export var stoneActive = "Tabs-module--stoneActive--18bd1";
export var stonePanel = "Tabs-module--stonePanel--692c2";
export var stoneTab = "Tabs-module--stoneTab--11e1d";
export var stoneTabs = "Tabs-module--stoneTabs--77deb";
export var stoneTabsLButton = "Tabs-module--stoneTabsLButton--576e7";
export var stoneTabsRButton = "Tabs-module--stoneTabsRButton--ff649";
export var stoneTabsWrapper = "Tabs-module--stoneTabsWrapper--3c464";
export var tideActive = "Tabs-module--tideActive--b3520";
export var tidePanel = "Tabs-module--tidePanel--71145";
export var tideTab = "Tabs-module--tideTab--a9dc4";
export var tideTabs = "Tabs-module--tideTabs--3b314";